export default __webpack_public_path__ + "static/media/lp-sec03_earnings.b85fd2bd.png";